import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, Jsonp, URLSearchParams } from '@angular/http';
// import { User } from '../models/user';
import {AppConfig} from '../../app.config';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import { Subject }    from 'rxjs/Subject';
@Injectable()
export class RoleService {
    constructor(private http: Http, private config: AppConfig, private _jsonp: Jsonp) { }

    saveRole(user: any) {
      return this.http.post(this.config.apiUrl +'role/create', user, this.setHeaders()).map((response: Response) => response.json());
    }
    getAllRole() {
        return this.http.get(this.config.apiUrl +'role/get-all', this.setHeaders()).map((response: Response) => response.json());
    }
    getRoleById(id:any) {
     return this.http.post(this.config.apiUrl +'role/find-by-id',{id:id}, this.setHeaders()).map((response: Response) => response.json());
    }
    getAllActiveRole() {
        return this.http.get(this.config.apiUrl +'role/get-all-active', this.setHeaders()).map((response: Response) => response.json());
    }
    // deleteRole(id: any) {
    //     return this.http.post(this.config.apiUrl +'admin/city/delete-city',{id:id}, this.setHeaders()).map((response: Response) => response.json());
    // }
    updateRole(role:any) {
        return this.http.put(this.config.apiUrl +'role/update', role, this.setHeaders()).map((response: Response) => response.json());
    }
    private setHeaders(params?: any) {
        // create authorization header with jwt token
        let token = localStorage.getItem('token');
        if (token) {
            // console.log('token >>>' + token);
            let headers = new Headers({ 'x-roamingse-token': token });
            if(params)
                return new RequestOptions({ headers: headers , search : params });
            else
                return new RequestOptions({ headers: headers });
        }else{
            return new RequestOptions({});
        }
    }
}



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/shared/services/role.service.ts